import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { PersonalUserData, CoiData, UserMinimalData, UserMicroData, UserMicroData_CircleDataExtended } from '../personal-user-data/personal-user-data';
import { HttpClient } from '@angular/common/http';
import { APIS } from 'src/app/apis';

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractUserCoiService {
  public abstract getUserCOI(orgIdOverride : string, userIdOverride?: string, retrieveRootLevelUsers?:boolean): Observable<CoiData>;
  public abstract usersOfInterestToTeam(): Observable<UserMinimalData[]> ;
  public abstract getUsersToExpandPersonOfInterest(): Observable<UserMicroData_CircleDataExtended[]>;
  public abstract getManagersBelow(orgIdOverride: string): Observable<UserMicroData[]>;
  public abstract getUsersUnderNLevels(userIdOverride: string, nLevels : number): Observable<UserMicroData_CircleDataExtended[]>;
}

